import React from 'react';
import { TypedInput } from '@hummingbirdtechgroup/wings-ui';
import { InputWrapper } from '..';
const EmailInput = (props) => React.createElement(TypedInput, { type: "text", ...props });
EmailInput.Controlled = (props) => {
    const { validations = [] } = props;
    const EmailValidation = {
        message: 'Emails must be in the correct format',
        isValid: value => /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(value),
    };
    const newProps = { ...props, validations: [EmailValidation, ...validations] };
    return (React.createElement(InputWrapper, { ...newProps },
        React.createElement(EmailInput, null)));
};
export default EmailInput;
//# sourceMappingURL=EmailInput.js.map